import { EvmAddress } from "./evm";
import { SolanaAddress } from "./solana";

export { SolanaAddress } from "./solana";
export { EvmAddress } from "./evm";
export type { SolanaAccountSummary, TokenAddressKind } from "./solana";

/** Supported chains for address validation. */
export type AddressChain = "solana" | "evm";

/**
 * Cross-chain shape gate. Routes to the chain's `isShape`. Use when
 * the chain is dynamic at the call site (e.g. a form that selects
 * which chain to send to).
 *
 * For deeper per-chain checks — Solana wallet validation, on-chain
 * lookup, future EIP-55 checksum — reach directly into the chain
 * namespace (`SolanaAddress.isWallet(...)`, `SolanaAddress.fetchAccount(...)`).
 * This router only knows about Tier-1 shape; it does *not* layer
 * Tier 2/3 checks even when the chain supports them, because the
 * choice of strictness is a per-call-site decision.
 */
export function isValidAddress(address: string, chain: AddressChain): boolean {
    switch (chain) {
        case "solana":
            return SolanaAddress.isShape(address);
        case "evm":
            return EvmAddress.isShape(address);
    }
}
